import React from "react";

const Footer = () => (
  <footer>
    <div>
      Creado por <a href="https://flavio3312.github.io/Card/">Flavio Perez</a>
    </div>
    <div>
      <a href="https://github.com/Flavio3312/pokemons-find">GitHub</a>
    </div>
  </footer>
);

export default Footer;
